import { StyleSheet, Platform, useWindowDimensions } from 'react-native'

export default function useNouvelleDemande(){
  const { width } = useWindowDimensions();
  const isTablet = width >= 768;
  const tabletScale = 1.5

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: '#fff',
      gap: 10,
    },

    scrollContainer: {
      flexGrow: 1,
      gap: 10,
      padding: 16,
    },

    // Contenu principal
    mainContent: {
      flex: 1,
      gap: 15,
    },

    // Styles pour les cartes
    card: {
      backgroundColor: 'white',
      borderRadius: 12,
      padding: 16,
      gap: 10,

      ...Platform.select({
        ios: {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.1,
          shadowRadius: 4,
        },
        android: {
          elevation: 3,
        },
        web: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      }),
      borderWidth: 1,
      borderColor: '#e5e7eb',
    },

    cardContentContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
    },

    // Nature d'absence
    natureAbsenceContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    natureAbsenceButton: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 16,
    },

    natureAbsenceText: {
      fontSize: 18,
      color: '#374151',
      fontWeight: '600',
      flex: 1,
    },

    natureAbsencePlaceholder: {
      fontSize: 18,
      color: '#9ca3af',
      fontWeight: '500',
      flex: 1,
    },

    droitsButton: {
      padding: 12,
      borderRadius: 8,
    },

    // Dates et heures
    dateCardButton: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      width: '40%',
    },

    dateCardRemplissage: {
      width: 30
    },

    dateButton: {
      backgroundColor: '#3b82f6',
      height: 70,
      borderRadius: 16,
    },

    dateButtonText: {
      fontWeight: 'bold',
      color: 'white',
      fontSize: 16,
      textAlign: 'center',
    },

    datePlaceholder: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 24,
    },

    datePlaceholderText: {
      fontWeight: 'bold',
      color: '#6b7280',
      fontSize: 18,
      textAlign: 'center',
    },

    // Calendrier
    calendarContainer: {
      height: 550,
      gap: 10
    },

    calendarValidateButton: {
      backgroundColor: '#3b82f6',
      height: 50,
      borderRadius: 10,
      justifyContent: 'center',
      alignItems: 'center',
    },

    calendarValidateText: {
      fontWeight: 'bold',
      color: 'white',
      fontSize: 16,
    },

    heureText: {
      color: '#374151',
      fontSize: 18,
      fontWeight: 'bold',
    },

    // Plages rapides (matin/après-midi)
    plageItem: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10
    },

    plageText: {
      fontStyle: 'italic',
      color: '#6b7280',
      flexWrap: 'wrap',
    },

    switchStyle: {
      marginRight: 8,
    },

    // Durée
    dureeText: {
      fontWeight: 'bold',
      color: '#374151',
      fontSize: 18,
      textAlign: 'center',
    },

    // Prévision
    previsionContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },

    // Fichier joint
    fichierContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    fichierButton: {
      flexDirection: 'row',
      alignItems: 'center',
    },

    fichierText: {
      fontStyle: 'italic',
      paddingLeft: 8,
      color: '#6b7280',
      fontWeight: 'bold',
    },

    // Commentaire
    commentaireInput: {
      borderWidth: 1,
      borderColor: '#d1d5db',
      borderRadius: 8,
      padding: 12,
      fontSize: 16,
      color: '#374151',
      backgroundColor: '#f9fafb',
      textAlignVertical: 'top',
      minHeight: 80,
    },

    // Boutons d'action
    buttonsContainer: {
      paddingVertical: 24,
      paddingHorizontal: 16,
      backgroundColor: '#f9fafb',
    },

    buttonsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
    },

    buttonPrimary: {
      flex: 1,
      backgroundColor: '#3b82f6',
      paddingVertical: 16,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
    },

    buttonPrimaryDisabled: {
      backgroundColor: '#3b82f655',
    },

    buttonSecondary: {
      flex: 1,
      backgroundColor: '#ef4444',
      paddingVertical: 16,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
    },

    buttonText: {
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
    },

    // Animation et états
    animationContainer: {
      flex: 1,
      justifyContent: 'flex-end',
      alignItems: 'center',
    },

    // États de désactivation
    disabled: {
      opacity: 0.5,
    },

    // En-tête de dotation
    dotationHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderRadius: 8,
    },

    dotationItem: {
      alignItems: 'center',
    },

    dotationReste: {
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
    },

    dotationValue: {
      fontSize: 16 * (isTablet ? tabletScale : 1),
      fontWeight: 'bold',
      color: '#3b82f6',
    },

    dotationLabel: {
      fontSize: 12 * (isTablet ? tabletScale : 1),
      color: '#6b7280',
    },

    dotationResteValue: {
      fontSize: 26 * (isTablet ? tabletScale : 1),
      fontWeight: 'bold',
      color: '#3b82f6',
    },

    dotationResteLabel : {
      fontSize: 22 * (isTablet ? tabletScale : 1),
      color: '#6b7280',
    },

    // Modal pour la sélection de nature d'absence
    modalContainer: {
      flex: 1,
      padding: 20,
    },

    modalItem: {
      backgroundColor: 'white',
      padding: 16,
    },

    modalItemText: {
      fontSize: 16,
      color: '#374151',
    },

    modalHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: 16,
      borderBottomWidth: 1,
      borderBottomColor: '#e5e7eb',
    },

    modalTitle: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#374151',
    },

    modalItemBadge: {
      fontSize: 12,
      color: '#6b7280',
      backgroundColor: '#f3f4f6',
      paddingHorizontal: 8,
      paddingVertical: 2,
      borderRadius: 4,
      marginLeft: 8,
    },

    emptyListContainer: {
      alignItems: 'center',
      paddingVertical: 40,
    },

    emptyListText: {
      fontSize: 16,
      color: '#6b7280',
      textAlign: 'center',
    },

    modalItemContent: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    lottie: {
      width: '75%',
      height: 150,
      position: 'absolute',
      bottom: 0,
    },

    // Styles ajoutés pour la version propre
    customHeaderContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 10,
    },

    customHeaderText: {
      fontSize: 20,
      fontWeight: 'bold',
      color: '#00448F',
    },

    // Nouveaux styles pour la gestion de documents
    documentInfoContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: '#f8fafc',
      borderRadius: 8,
      padding: 12,
      marginBottom: 8,
      borderWidth: 1,
      borderColor: '#e2e8f0',
    },

    documentInfoContent: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },

    documentInfoText: {
      marginLeft: 12,
      flex: 1,
    },

    documentFileName: {
      fontSize: 16,
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: 2,
    },

    documentFileInfo: {
      fontSize: 12,
      color: '#6b7280',
    },

    documentActions: {
      flexDirection: 'row',
      alignItems: 'center',
    },

    documentActionButton: {
      padding: 8,
      marginLeft: 8,
      borderRadius: 6,
      backgroundColor: '#f1f5f9',
    },

    documentErrorContainer: {
      backgroundColor: '#fef2f2',
      borderRadius: 8,
      padding: 12,
      marginTop: 8,
      borderWidth: 1,
      borderColor: '#fecaca',
    },

    documentErrorText: {
      fontSize: 14,
      color: '#dc2626',
      textAlign: 'center',
    },
  });

  return { styles };
}
